import { PageFooter } from '../components/layout/PageFooter';
import { product, support } from '../business/content/siteContent';
import './MainPage.css';
import './PrivacyPage.css';

const updatedAt = '2026年7月18日';

export function PrivacyPage() {
  return (
    <div className="site-shell">
      <header className="privacy-header">
        <a className="brand" href="/" aria-label="NASLink トップページへ">
          <span className="brand-mark" aria-hidden="true">N</span>
          {product.name}
        </a>
      </header>

      <main className="privacy-main">
        <div className="privacy-intro">
          <p className="eyebrow">PRIVACY POLICY</p>
          <h1>プライバシー<br />ポリシー</h1>
          <p>
            NASLink（以下「本アプリ」）は、利用者のプライバシーを尊重し、
            本アプリで取り扱う情報を以下のとおり管理します。
          </p>
          <p className="privacy-date">制定・最終更新：{updatedAt}</p>
        </div>

        <article className="privacy-content">
          <PolicySection title="1. 適用範囲">
            <p>
              本ポリシーは、iOSおよびAndroid向けの本アプリと、本ウェブサイトに
              適用されます。利用者が本アプリを通じて接続するTailscale、SMBサーバー、
              Apple、Googleその他の第三者サービスには、各提供者の規約と
              プライバシーポリシーが適用されます。
            </p>
          </PolicySection>

          <PolicySection title="2. 本アプリが端末内で取り扱う情報">
            <ul>
              <li>SMBサーバーの表示名、ホスト名またはIPアドレス、ポート、共有名、フォルダーパス</li>
              <li>SMBユーザー名およびパスワード</li>
              <li>Tailscaleへの接続に必要な認証状態および端末情報</li>
              <li>本アプリの設定、Pro購入状態のキャッシュ、操作により作成される一時キャッシュ</li>
              <li>利用者が許可した写真、動画、音声、書類その他の端末内ファイル</li>
            </ul>
            <p>
              SMB認証情報はOSが提供するセキュアストレージに保存します。
              サーバー設定やアプリ設定は端末内に保存します。SMB上または端末内の
              ファイルは、閲覧、再生、コピー、移動、保存等、利用者が選択した機能を
              提供するためにのみ処理します。
            </p>
          </PolicySection>

          <PolicySection title="3. 外部へ送信される情報">
            <h3>Firebase Analytics</h3>
            <p>
              画面の閲覧、アプリの起動などの利用状況、端末・OS・アプリの情報、
              おおよその地域、広告識別子等がGoogleへ送信される場合があります。
              本アプリの利用状況の把握と改善に利用します。
            </p>

            <h3>Firebase Crashlytics</h3>
            <p>
              クラッシュログ、スタックトレース、端末・OS・アプリの情報、
              クラッシュ発生時の状態等がGoogleへ送信される場合があります。
              不具合の調査と品質改善に利用します。
            </p>

            <h3>Google AdMob</h3>
            <p>
              広告の表示・計測・不正防止・パーソナライズのため、広告識別子、
              IPアドレス、端末情報、広告への反応、診断情報等がGoogleおよび
              広告パートナーへ送信される場合があります。法令上必要な地域では、
              Google User Messaging Platformを通じて同意を確認します。
              Pro版では広告を表示しません。
            </p>

            <h3>App Store・Google Play</h3>
            <p>
              Pro版の購入と復元はAppleまたはGoogleの決済機能を利用します。
              購入処理に必要な商品情報、取引結果および購入状態を取り扱います。
              支払情報そのものを本アプリが取得・保存することはありません。
            </p>

            <h3>Tailscale・SMBサーバー</h3>
            <p>
              Tailscaleへの接続時は、認証・ネットワーク接続に必要な情報が
              Tailscaleへ送信されます。SMB接続情報とファイル内容は、利用者が
              指定したSMBサーバーとの間で直接送受信されます。
            </p>
          </PolicySection>

          <PolicySection title="4. 送信しない情報">
            <p>
              本アプリの運営者が管理する独自サーバーへ、SMBユーザー名・パスワード、
              TailnetのIPアドレスやMagicDNS名、共有名、フォルダーパス、
              SMB上または端末内のファイル内容を送信することはありません。
              また、これらをFirebase Analyticsのイベント値やCrashlyticsの
              カスタム情報として意図的に記録しません。
            </p>
          </PolicySection>

          <PolicySection title="5. フォルダー招待">
            <p>
              利用者がフォルダー招待を作成した場合、招待ID、有効期限、
              サーバー表示名、TailnetのIPアドレスまたはMagicDNS名、SMBポート、
              共有名およびフォルダーパスを含むリンクが生成されます。
              SMBユーザー名とパスワードは含まれません。リンクは利用者が選択した
              OSの共有先へ渡されるため、信頼できる相手とのみ共有してください。
            </p>
          </PolicySection>

          <PolicySection title="6. 権限の利用">
            <p>
              Androidでは、端末内ファイルを管理する中核機能のため、
              OSバージョンに応じてストレージへのアクセス権限を使用します。
              iOSでは、利用者が許可した写真・動画へのアクセス権限を使用します。
              生体認証を有効にした場合、認証結果のみを利用し、生体情報そのものを
              本アプリが取得・保存することはありません。
            </p>
          </PolicySection>

          <PolicySection title="7. 保存期間と削除">
            <p>
              サーバー設定、認証情報およびアプリ設定は、利用者が削除するか
              本アプリをアンインストールするまで端末内に保存されます。
              プレビュー用データは一時キャッシュとして保存され、設定画面から
              削除できます。第三者サービスへ送信された情報の保存期間と削除方法は、
              各サービス提供者のポリシーに従います。
            </p>
          </PolicySection>

          <PolicySection title="8. 利用者による選択">
            <p>
              端末のOS設定から写真、ストレージ、広告トラッキング等の権限を
              変更できます。対象地域では、本アプリの設定画面にある
              「広告のプライバシー設定」から同意内容を見直せます。
              権限を無効にすると、一部機能が利用できなくなる場合があります。
            </p>
          </PolicySection>

          <PolicySection title="9. 第三者提供・国外での処理">
            <p>
              本ポリシーに記載した機能提供、法令遵守、権利保護のために必要な場合を
              除き、利用者情報を第三者へ販売しません。Google、Apple、Tailscale等の
              事業者による処理は、利用者の居住国以外で行われる場合があります。
            </p>
          </PolicySection>

          <PolicySection title="10. 子どものプライバシー">
            <p>
              本アプリは、保護者の同意なく児童から個人情報を収集することを
              意図していません。法令で保護者の同意が必要な年齢の方は、
              保護者の同意を得たうえで利用してください。
            </p>
          </PolicySection>

          <PolicySection title="11. 本ポリシーの変更">
            <p>
              法令や本アプリの機能変更等に応じて、本ポリシーを改定することがあります。
              重要な変更がある場合は、本ウェブサイトまたは本アプリ内で通知します。
              改定後のポリシーは、本ページへ掲載した時点から適用されます。
            </p>
          </PolicySection>

          <PolicySection title="12. お問い合わせ">
            <p>
              本ポリシーまたは本アプリに関するお問い合わせは、
              下記の窓口までご連絡ください。
            </p>
            <p>
              メール：<a href={`mailto:${support.email}`}>{support.email}</a>
              <br />
              サポートページ：<a href="/support">https://naslink-remote-smb-files.web.app/support</a>
            </p>
          </PolicySection>
        </article>
      </main>

      <PageFooter productName={product.name} />
    </div>
  );
}

function PolicySection({ title, children }) {
  return (
    <section className="policy-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}
